export class PageBlockLiveAuction {

    public blockTitle = null;
    public campaignData = null;
    public campaignId = null;
    public faq = null;
    public id = null;
    public imageUrl = null;
    public removeFromNav = null;
    public slides = null;
    public text = null;
    public type = null;

    constructor(pageBlockLiveAuction) {
        this.blockTitle = pageBlockLiveAuction.blockTitle;
        this.campaignData = pageBlockLiveAuction.campaignData;
        this.campaignId = pageBlockLiveAuction.campaignId;
        this.faq = pageBlockLiveAuction.faq;
        this.id = pageBlockLiveAuction.id;
        this.imageUrl = pageBlockLiveAuction.imageUrl;
        this.removeFromNav = pageBlockLiveAuction.removeFromNav;
        this.slides = pageBlockLiveAuction.slides;
        this.text = pageBlockLiveAuction.text;
        this.type = pageBlockLiveAuction.type;
    }

    getMenuElement(url, index) {

        if(!this.isArchivedOrDeactivated() && !this.isCampaignExpaired()) {
            const liveAuctionName = this.blockTitle || this.campaignData.name;

            return {
                href: url + '#live-auction-' + index,
                name: liveAuctionName.replace(/<[^>]*>/g, '')
            }
        } 
        return null;
    }

    isArchivedOrDeactivated() {
        return this.campaignData.status === 5 || this.campaignData.status === 2;
    }

    isCampaignExpaired() {
        return +new Date() > +new Date(this.campaignData.endDate);
    }
}